import React from 'react'
import {
    FloppyDiskIcon,
    FolderOpenIcon,
    ArrowCounterClockwiseIcon,
    InfoIcon,
} from '@phosphor-icons/react'
import { useExplorer } from '../../../context/explorer'
import { ScoopRow, ScoopText } from '../../ui'
import { ScoopButton } from '../../ui/ScoopButton/ScoopButton'
import { ScoopTooltip } from '../../ui/ScoopTooltip/ScoopTooltip'
import styles from './ExplorerV2.module.scss'

/**
 * Header component for Explorer.
 * Contains title, info tooltip, and action buttons (Open, Save, Reset).
 */
export const ExplorerHeader = () => {
    const { reset, hasSelectedItems } = useExplorer()

    const handleOpen = () => {
        // TODO: Implement open dialog in Stage 10
        console.log('Open clicked')
    }

    const handleSave = () => {
        // TODO: Implement save dialog in Stage 10
        console.log('Save clicked')
    }

    return (
        <header className={styles.explorerHeader}>
            <ScoopRow className={styles.headerTitle}>
                <ScoopText className={styles.headerTitleText}>Explorer</ScoopText>
                <ScoopTooltip
                    title={
                        <span>
                            Use{' '}
                            <a
                                href="https://docs.scoopanalytics.com/docs/visualizing-charts-and-tables"
                                target="_blank"
                                rel="noreferrer"
                                style={{ color: '#E50B54' }}
                            >
                                our guide
                            </a>{' '}
                            to learn more.
                        </span>
                    }
                    placement="bottom"
                >
                    <InfoIcon size={18} style={{ cursor: 'pointer', opacity: 0.7 }} />
                </ScoopTooltip>
            </ScoopRow>

            <ScoopRow className={styles.headerActions}>
                <ScoopButton
                    variant="outline"
                    size="xs"
                    onClick={handleOpen}
                    leftSection={<FolderOpenIcon size={16} />}
                >
                    Open
                </ScoopButton>

                <ScoopButton
                    variant="outline"
                    size="xs"
                    onClick={handleSave}
                    disabled={!hasSelectedItems}
                    leftSection={<FloppyDiskIcon size={16} />}
                >
                    Save
                </ScoopButton>

                <ScoopButton
                    variant="outline"
                    size="xs"
                    onClick={reset}
                    disabled={!hasSelectedItems}
                    leftSection={<ArrowCounterClockwiseIcon size={16} />}
                >
                    Reset
                </ScoopButton>
            </ScoopRow>
        </header>
    )
}
